import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { API } from "@/lib/api";
import { REVIEWS } from "@/data/reviews";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";

function Stars({ n = 5 }) {
  return (
    <span className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
      {Array.from({ length: n }).map((_, i) => (
        <Star key={i} size={13} className="fill-rw-green text-rw-green" />
      ))}
    </span>
  );
}

export function Testimonials() {
  const [reviews, setReviews] = useState(REVIEWS || []);
  useEffect(() => {
    API.get("/reviews").then((r) => {
      if (r?.data?.items?.length) setReviews(r.data.items);
    }).catch(() => {});
  }, []);

  const published = reviews.filter((r) => r.status === "published");
  if (!published.length) return null;

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-rw-bg2 border-y border-rw-border" data-testid="testimonials-section">
      <div className="container-rw">
        <SectionHead
          eyebrow="Client Reviews"
          title="What businesses say about working with us."
          description="Feedback from SEO and website development engagements — stores built, rankings grown, enquiries earned."
          testid="testimonials-head"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {published.slice(0, 12).map((r, i) => (
            <Reveal key={r.order ?? i} delay={(i % 3) * 0.07}>
              <figure className="relative h-full rounded-2xl border border-rw-border bg-rw-card p-6 transition-all duration-300 hover:border-rw-green/40 hover:-translate-y-1"
                data-testid={`review-card-${i + 1}`}>
                <Quote size={20} className="absolute right-5 top-5 text-rw-border2" aria-hidden="true" />
                <Stars n={r.rating || 5} />
                <blockquote className="mt-4 text-sm leading-relaxed text-rw-muted">"{r.text}"</blockquote>
                <figcaption className="mt-5 border-t border-rw-border/60 pt-4">
                  <span className="font-jakarta text-xs font-bold text-rw-text">{r.role || r.name}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
